import { useTranslation } from 'react-i18next';
var useOffersDictionaryConverter = function () {
    var t = useTranslation().t;
    var getDictionaryValues = function (offerName) {
        var dictionaryValues = {
            'Military Discount': {
                label: t('Pages.Bap.militaryDiscountLabel'),
                tooltip: t('Pages.Bap.militaryDiscountTooltipText'),
            },
            'Student Discount': {
                label: t('Pages.Bap.studentDiscountLabel'),
                tooltip: t('Pages.Bap.studentDiscountTooltipText'),
            },
            'Newcomer to Canada': {
                label: t('Pages.Bap.newcomerToCanadaLabel'),
                tooltip: t('Pages.Bap.newcomerToCanadaTooltipText'),
            },
            'Loyalty Rate Reduction': {
                label: t('Pages.Bap.loyaltyRateReductionLabel'),
                tooltip: t('Pages.Bap.loyaltyRateReductionTooltipText'),
            },
            'Loyalty Rebate': {
                label: t('Pages.Bap.loyaltyRebateLabel'),
                tooltip: t('Pages.Bap.loyaltyRebateTooltipText'),
            },
            'Special sales event': {
                label: t('Pages.Bap.specialSalesEventLabel'),
                tooltip: undefined,
            },
            'Federal IZEV program incentive': {
                label: t('Pages.Bap.federalIncentiveLabel'),
                tooltip: t('Pages.Bap.federalIncentiveTooltipText'),
            },
            'Provincial IZEV program incentive': {
                label: t('Pages.Bap.provincialIncentiveLabel'),
                tooltip: t('Pages.Bap.provincialIncentiveTooltipText'),
            },
        };
        return dictionaryValues[offerName] || { tooltip: undefined, label: undefined };
    };
    return {
        getDictionaryValues: getDictionaryValues,
    };
};
export default useOffersDictionaryConverter;
